import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FlashNotification } from '../shared/flash-notification/flash-notification';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, FlashNotification],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App {
  // constructor(
  //   private schoolService: SchoolService,
  //
  // ) {}
  //
  // ngOnInit(): void {
  //   this.schoolService.getSchool().subscribe({
  //     next: (school) => {
  //       this.themeService.setTheme(school.primary_color, school.secondary_color);
  //     },
  //   });
  // }

  protected readonly title = signal('school-mgt-frontend');
}
